<div>
  <div class="spinner-container">
    <mat-progress-spinner color="primary" mode="determinate" diameter="120" strokeWidth="10" [value]="value"></mat-progress-spinner>
    <div class="progress-value">{{value | number:'1.0-0'}}%</div>
  </div>
  
  <div class="c-secondary text-center pb-10">{{messages[currentMessageIndex]}}...</div>
</div>
